<template>
    <div class="verified-seller">
        <div class="dokan-logical-container" v-if="!isLoading">
            <ul>
                <li class="dokan-logical-label-li" v-for="(level, index) in this.badge_levels" :key="level.level_condition">
                    <span class="badge-level">{{ sprintf( __( 'Level %d', 'dokan' ), index + 1 ) }}</span>
                    <div class="level-condition">
                        {{ event.condition_text.prefix }}
                        <div class="input-group">
                            <span class="input-group-text">
                                <i class="icon" :class="getBadgeEvent().input_group_icon.condition"></i>
                            </span>
                            <select v-model="badge_levels[index].level_condition" v-on:change="disableVerificationTypeOptions(index)">
                                <option value="" disabled selected>{{ __('Select a method', 'dokan') }}</option>
                                <option v-for="(verification_type, verification_id) in verificationTypes" :value="verification_type.id" :disabled="verification_type.disabled">
                                    {{ verification_type.title }}
                                </option>
                            </select>
                        </div>
                        <span v-if="event.condition_text.suffix">{{event.condition_text.suffix}}</span>
                        <i class="remove-level" @click.prevent="removeLevel(index)" v-show="( index > 0 )" :title="__('Remove badge level', 'dokan')"></i>
                    </div>
                </li>
            </ul>
            <div>
                <button @click.prevent="addLevel" :disabled="this.addNewButtonDisabled" class="button button-secondary">+ {{ __('Add More', 'dokan') }}</button>
            </div>
        </div>
        <div class="loader" v-if="isLoading">
            <Bars width="64" height="64" color="#007bff" />
        </div>
    </div>
</template>

<script>
import defaultBadgeLevelData from "../../../BadgeLevel.json";
import Bars from "../../../components/Bars.vue";
import mixin from "../../../Mixin.js";

export default {
    name: 'VerifiedSeller',

    mixins: [mixin],

    components: {
        Bars,
    },

    props: {
        event: {
            type: Object,
            default () {
                return this.getDefaultLevelObject();
            },
        },
    },

    data () {
        return {
            verificationTypes: {},
            badge_levels: this.getLevels(),
            addNewButtonDisabled: false,
            isLoading: false,
        }
    },

    inject: ['setBadgeLevels', 'getBadgeLevels', 'getBadgeEvent'],

    created () {
        this.$watch(
            () => this.$route.params,
            () => {
                this.getVerificationTypeData();
            },
            // fetch the data when the view is created and the data is
            // already being observed
            { immediate: true }
        );

        this.$watch('badge_levels', (newLevels) => {
            this.setBadgeLevels( this.badge_levels );
        });

        this.disableAddNewButton();
    },

    updated () {
        this.disableAddNewButton();
    },

    mounted() {
        this.disableAddNewButton();
        this.disableVerificationTypeOptions();
    },

    activated() {
        // keep-alive
        // called on initial mount
        // and every time it is re-inserted from the cache
        this.setBadgeLevels( this.badge_levels );
    },

    deactivated() {
        // keep-alive
        // called when removed from the DOM into the cache
        // and also when unmounted
    },

    methods: {
        getLevels() {
            if ( ! this.getBadgeLevels().length ) {
                return [
                    this.getDefaultLevelObject(),
                ]
            }
            return this.getBadgeLevels();
        },

        getDefaultLevelObject() {
            let data = Object.assign( {}, defaultBadgeLevelData );
            data.level_condition = '';
            data.level_data = 1;
            return data;
        },

        addLevel() {
            this.badge_levels.push( this.getDefaultLevelObject() );
            this.disableAddNewButton();
        },

        removeLevel(index) {
            const selected_method = this.badge_levels[index].level_condition;
            if ( undefined !== this.verificationTypes[selected_method] ) {
                this.verificationTypes[selected_method].disabled = false;
            }

            this.badge_levels.splice( index, 1 );
        },

        disableVerificationTypeOptions( index ) {
            for ( const index of Object.keys( this.verificationTypes ) ) {
                this.verificationTypes[index].disabled = false;
            }
            for ( const level of this.badge_levels ) {
                if ( undefined !== this.verificationTypes[level.level_condition] ) {
                    this.verificationTypes[level.level_condition].disabled = true;
                }
            }
        },

        disableAddNewButton() {
            // check if user selected a method already for last level
            const length = this.badge_levels.length - 1;
            if ( '' === this.badge_levels[length].level_condition ) {
                this.addNewButtonDisabled = true;
                return;
            }
            // check if we've available verification method to choose from
            for ( const index in this.verificationTypes ) {
                if ( false === this.verificationTypes[index].disabled ) {
                    this.addNewButtonDisabled = false;
                    return;
                }
            }
            this.addNewButtonDisabled = true;
        },

        async getVerificationTypeData() {
            this.isLoading = true;
            this.verificationTypes = await this.fetchVerificationTypes();
            this.disableVerificationTypeOptions();
            this.isLoading = false;
        },
    },
}
</script>

<style lang="less" scoped>
.dokan-logical-container {
    .badge-level {
        background: #B9B9B9;
        border-radius: 1rem;
        padding: 0.3rem 1rem;
        vertical-align: middle;
        display: inline-block;
        margin-bottom: 1rem;
        line-height: 16px;
        letter-spacing: 0.08px;
        color: #FFFFFF;
        font-size: 0.75rem;
        font-weight: 600;
    }

    .remove-level {
        background: url('../../../../images/others/close.svg');
        width: 14px;
        height: 14px;
        line-height: 17px;
        display: inline-block;
        vertical-align: middle;
        cursor: pointer;
    }

    .level-condition {
        display: flex;
        align-items: center;
        gap: 1rem;
        font-size: 0.875rem;

        select {
            border: 1px solid #e2e2e2;
            border-radius: 3px;
            height: 42px ;
            font-size: 15px;
        }
    }
}
</style>
